import { z } from "zod";
import {
  ErrorIdSchema,
  HerSkinRunIdSchema,
  HerSkinSessionIdSchema,
  IsoDateTimeSchema,
} from "./common.js";

export const RunStatusSchema = z.enum([
  "submitting",
  "accepted",
  "running",
  "waiting_approval",
  "waiting_clarification",
  "stopping",
  "completed",
  "failed",
  "stopped",
  "unknown",
  "recovering",
]);

export const RunTriggerSchema = z
  .object({
    kind: z.literal("manual"),
    label: z.literal("手动会话"),
  })
  .strict();

export const RunSummarySchema = z
  .object({
    id: HerSkinRunIdSchema,
    sessionId: HerSkinSessionIdSchema,
    status: RunStatusSchema,
    trigger: RunTriggerSchema,
    createdAt: IsoDateTimeSchema,
    startedAt: IsoDateTimeSchema.nullable(),
    completedAt: IsoDateTimeSchema.nullable(),
    errorId: ErrorIdSchema.optional(),
  })
  .strict();

/**
 * 对结果未知的 Run，只允许两种显式人工结论。confirm 使用固定字面量，
 * 避免按钮误触或通用 API 客户端把普通 PATCH 当成不可逆的结果裁决。
 */
export const ResolveRunRequestSchema = z
  .object({
    outcome: z.enum(["completed", "failed"]),
    confirm: z.literal("resolve_unknown_result"),
  })
  .strict();

export const RunRecoveryResponseSchema = z
  .object({
    sessionId: HerSkinSessionIdSchema,
    runId: HerSkinRunIdSchema,
    state: z.enum(["running", "completed", "failed", "confirmation_required"]),
    runStatus: RunStatusSchema,
    reason: z.enum([
      "remote_running",
      "remote_history_completed",
      "remote_history_unchanged",
      "prompt_not_attempted",
      "remote_evidence_insufficient",
      "already_resolved",
      "user_confirmed",
    ]),
    attachmentResolution: z.enum(["none", "consumed", "failed", "unknown"]),
    resolvedBy: z.enum(["remote_evidence", "user_confirmation"]).nullable(),
    idempotent: z.boolean(),
    updatedAt: IsoDateTimeSchema,
  })
  .strict();

export type RunStatus = z.infer<typeof RunStatusSchema>;
export type RunSummary = z.infer<typeof RunSummarySchema>;
export type ResolveRunRequest = z.infer<typeof ResolveRunRequestSchema>;
export type RunRecoveryResponse = z.infer<typeof RunRecoveryResponseSchema>;
